const locale: Locale = {
  ko: {
    answered: '답변완료',
    rejected: '청원반려',
    expired: '청원기간만료',
    waiting: '답변대기중',
    inProgress: '청원진행중',
    prior: '사전동의진행중',

    prgoress: '진행 상황',
    category: '분류',
    title: '제목',
    duration: '청원 기간',
    supporters: '참여인원',

    empty: '나의 청원이 없습니다.',
    create: '청원을 등록해주세요!',

    people: '명',
  },
  en: {
    answered: 'Answered',
    rejected: 'Rejected',
    expired: 'Expired',
    waiting: 'Waiting Answer',
    inProgress: 'In Progress',
    prior: 'Prior Consent',

    prgoress: 'progress',
    category: 'category',
    title: 'title',
    duration: 'duration',
    supporters: 'supporters',

    empty: "There're no petitions.",
    create: 'Create your petition!',

    people: 'agreed',
  },
}

export default locale
